const appendZero = (number) => (number < 10 ? `0${number}` : number);
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const getFormattedDate = (date, separator, format) => {
  const newdate = new Date(date);
  const value = {
    DD: appendZero(newdate.getDate()),
    MM: appendZero(newdate.getMonth() + 1),
    YY: appendZero(newdate.getFullYear()),
  };
  return format
    .split(separator)
    .map((field) => value[field])
    .join(separator);
};

export const getDay = (date) => {
  if (!date) return "";
  const dayIndex = new Date(date).getDay();
  return days[dayIndex];
};

export const getDate = (date) => {
  if (!date) return "";
  const newdate = new Date(date);
  return `${appendZero(newdate.getDate())} ${
    months[newdate.getMonth()]
  }, ${newdate.getFullYear()}`;
};

export function linkifyText(paragraph) {
  const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;

  return paragraph.replace(urlRegex, (url) => {
    let hyperlink = url;

    // Add http if missing (for www. links)
    if (!hyperlink.startsWith("http")) {
      hyperlink = "http://" + hyperlink;
    }

    return `<a rel="noreferrer" href="${hyperlink}" style="text-decoration:underline" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}

export function groupLessonPlans(lessonplans = []) {
  const colMap = {};
  const planIds = [];
  if (!lessonplans.length) return [];
  const totalRows = lessonplans.length;
  lessonplans.forEach((plan, pIndex) => {
    planIds.push(plan._id);
    const cols = [
      {
        colName: "Period",
        text: plan.time || "N/A",
        fixed: true,
      },
      {
        colName: "Grade",
        text: `${plan.sectionId?.grade}-${plan.sectionId?.section}`,
        fixed: true,
      },
      {
        colName: "Subject",
        text: plan?.subjectId?.name,
        fixed: true,
      },
      {
        colName: "Chapter/Topic/Sub Topic",
        text: `${plan?.chapterId?.name || plan.customChapter} /${
          plan?.topicId?.name || plan.customTopic
        } / ${plan.customModule || ""}`,
        fixed: true,
      },
      ...(plan.cols || []),
    ];
    return cols.forEach((col) => {
      const colName = col.colName.toLowerCase().trim();
      if (!colMap[colName]) {
        let cells = new Array(totalRows)
          .fill(undefined, 0, totalRows)
          .map((cell, index) => {
            if (pIndex === index) return col;
            if (!cell) {
              return {
                ...col,
                _id: "",
                text: "",
                lessonPlanId: lessonplans[index]._id,
                resources: [],
                new: true,
              };
            } else {
              return col;
            }
          });
        colMap[colName] = {
          lessonPlanId: col.lessonPlanId,
          teacherId: col.teacherId,
          colName: col.colName,
          colIndex: col.colIndex,
          fixed: col.fixed || false,
          cellIds: [col._id],
          cells,
        };
      } else {
        const savedCol = colMap[colName];
        savedCol.colIndex = Math.min(savedCol.colIndex, col.colIndex);
        savedCol.fixed = col.fixed || false;
        savedCol.cells[pIndex] = col;
        savedCol.cellIds.push(col._id);
        colMap[colName] = savedCol;
      }
    });
  });

  return Object.values(colMap).sort((a, b) => a.colIndex - b.colIndex);
}

export function buildQueryString({ teacherId, selectedGrades, dateFilter }) {
  const params = new URLSearchParams();

  // Add teacherId
  if (teacherId) {
    params.append("teacherId", teacherId);
  }

  // Handle sectionId + subjectId
  if (selectedGrades) {
    Object.entries(selectedGrades).forEach(([sectionId, subjects]) => {
      params.append("sectionId", sectionId);
      if (Array.isArray(subjects)) {
        subjects.forEach((subjectId) => {
          params.append("subjectId", subjectId);
        });
      }
    });

    // Handle fromDate/toDate
    if (dateFilter) {
      const { fromDate, toDate } = dateFilter;

      if (fromDate) {
        params.append("startDate[gte]", `${fromDate}T00:00:00`);
      }
      if (toDate) {
        params.append("startDate[lte]", `${toDate}T23:59:59`);
      }
    }
  }

  return params.toString();
}

// given element width in pixels, choose best page format
export function getPdfFormatByWidth(widthPx) {
  // convert px to pt (roughly 0.75 points per px at 96dpi)
  const widthPt = widthPx * 0.75;

  if (widthPt <= 595) return "a4";
  if (widthPt <= 842) return "a3";
  if (widthPt <= 1191) return "a2";
  return "a1"; // fallback largest
}
